import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const projectsApi = createApi({
  reducerPath: 'projectsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Content-Type', 'application/json');
      return headers;
    },
  }),
  tagTypes: ['ProjectCustomFields', 'ProjectSections'],
  keepUnusedDataFor: 300,
  endpoints: (builder) => ({
    getProjectCustomFields: builder.query({
      query: ({ projectId }) => ({
        url: `/customField/project/${projectId}`,
        method: 'GET',
      }),
      providesTags: (result, error, { projectId }) => [
        { type: 'ProjectCustomFields', id: projectId },
      ],
    }),
    getProjectSections: builder.query({
      query: ({ projectId }) => ({
        url: `/projects/${projectId}?members=true`,
        method: 'GET',
      }),
      transformResponse: (res) => res?.data?.sections || [],
      providesTags: (result, error, { projectId }) => [
        { type: 'ProjectSections', id: projectId },
      ],
    }),
  }),
});

export const { useGetProjectCustomFieldsQuery, useGetProjectSectionsQuery } = projectsApi;
